var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPersonHeart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "82px",
    viewBox: "0 0 60 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MVP_CompanyDESKTOP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Account-Selection",
    transform: "translate(-588.000000, -380.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(533.000000, 381.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(26.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(30.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-2",
    stroke: "#FFFFFF",
    fill: "#FFD110",
    cx: 29,
    cy: 20,
    rx: 21,
    ry: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.90417654,80 C0.673953939,76.8944005 0,73.5231915 0,70 C0,54.536027 12.9837423,42 29,42 C45.0162577,42 58,54.536027 58,70 C58,73.5231915 57.3260461,76.8944005 56.0958235,80 L1.90417654,80 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    fill: "#FFD110"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-1315",
    transform: "translate(31.000000, 53.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.39673636,0 C8.21462727,0 6.91281818,0.623622967 6.3,1.99172991 C5.69577273,0.645417575 4.42660909,0.031205915 3.27485455,0.031205915 C1.12540909,0.031205915 0,1.80152242 0,3.54905366 C0,6.61713997 3.4083,9.72287151 6.14135455,11.2990179 C6.24387273,11.3574671 6.37789091,11.3530091 6.47468182,11.2881206 C6.72496364,11.1206984 12.6,7.14268721 12.6,3.25581713 C12.6,1.11845962 10.9883455,0 9.39673636,0",
    id: "Fill-589"
  })))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPersonHeart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/person_heart.988c8880a721e279c029a7d73b0a7647.svg";